import {Component, computed, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Store} from '@ngrx/store';
import {AppState} from '../../../store/app-state';
import {filter, map, take} from 'rxjs/operators';
import {AppActions} from '../../../store/app-actions';
import {NavigationEnd, Router} from '@angular/router';
import {DashboardService} from '../../../dashboard/services/dashboard.service';
import {toSignal} from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.less']
})
export class HeaderComponent implements OnInit {
  @Input() showExitButton = false;
  @Input() showSupportRequestButton = false;
  @Output() feedbackButtonClick = new EventEmitter();

  supportPhone?: string | null;
  messengerPhone?: string | null;

  constructor(private store: Store<{ app: AppState }>,
              private router: Router,
              private dashboardService: DashboardService) {
  }

  readonly currentUrl = toSignal(
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(event => (event as NavigationEnd).urlAfterRedirects)
    ),
    {initialValue: this.router.url}
  );

  readonly newsButtonText = computed(() =>
    this.currentUrl() === '/news' ? 'На главную' : 'Новости'
  );

  readonly userStatementsButtonText = computed(() =>
    this.currentUrl() === '/statements' ? 'На главную' : 'Заявления абонента'
  );

  readonly userStatementsRoute = computed(() =>
    this.currentUrl() === '/statements' ? '' : '/statements'
  );

  readonly newsButtonRoute = computed(() =>
    this.currentUrl() === '/news' ? '' : '/news'
  );

  readonly isLogin = computed(() =>
  this.currentUrl() === '/login' ? 'dark' : 'light')

  ngOnInit(): void {
    // Getting common data from store
    this.store.select('app', 'commonData')
      .pipe(take(1))
      .subscribe(commonData => {
        this.supportPhone = commonData?.support_phone ?? null;
        this.messengerPhone = commonData?.messenger_phone ?? null;
      });

  }

  logout(): void {
    this.dashboardService.logout().subscribe();
    this.store.dispatch(AppActions.logout());
    this.router.navigate(['/login']);
  }

  onFeedbackButtonClick(): void {
    this.feedbackButtonClick.emit();
  }

  goTo(route: string): void {
    this.router.navigate([route]);
  }

}
